import Vue from 'vue'
import axios from 'axios'
import _ from 'lodash'
// import store from '@/store'
import qs from 'querystringify'
import getSignature from '@/utils/signature'

// const WENZHENG_API = process.env.VUE_APP_WENZHENG_API
// create an axios instance
const service = axios.create({
  // baseURL: process.env.VUE_APP_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000 // request timeout
})
// request interceptor
service.interceptors.request.use(
  (config) => {
    console.log('configconfig', config)
    const isPayment = config.url.includes(process.env.VUE_APP_PAYMENT_API) && location.pathname.includes('/payment')
    var signatureObj = getSignature()
    // do something before request is sent
    const { method, data, contentType } = config
    // if (url.startsWith('/wenzheng')) {
    //   config.baseURL = WENZHENG_API
    //   config.url = url.replace('/wenzheng', '')
    // }
    // parse data
    if (contentType === 'json') {
      config.headers['Content-Type'] = 'application/json'
    } else if (method !== 'get' && _.isObject(data)) {
      if (typeof config.headers['Content-Type'] === 'undefined' && !isPayment) {
        // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        if (!data.access_token) {
          data.access_token = sessionStorage.getItem('X-Authorization')
        }
        config.data = qs.stringify(data)
      }
    }
    if (config.params && !isPayment) {
      if (!config.params.access_token) {
        config.params.access_token = sessionStorage.getItem('X-Authorization')
      }
    }
    // 收银台此处不加签名
    if (!isPayment) {
      if (method == 'get' && config.params) {
        config.data = Object.assign(config.params, signatureObj)
      } else {
        config.params = signatureObj
      }
    }
    if (sessionStorage.getItem('X-Authorization')) {
      // config.headers['openid'] = '123123'
      config.headers['X-Authorization'] = sessionStorage.getItem('X-Authorization')
    }
    if (sessionStorage.getItem('luckdrawToken')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('luckdrawToken')
    }
    // if (store.getters.token) {
    // config.headers['X-Auth-Token'] = encodeURIComponent(getToken())
    // }
    // config.access_token = 'ca88056f41a65f98b8801c74a6e32bbe'
    // config.params = 'ca88056f41a65f98b8801c74a6e32bbe'
    return config
  },
  (error) => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data
    // console.log('++++++')
    // console.log(res)
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 0) {
      // if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      //   // to re-login
      // }
      if (res.code == 405) {
        sessionStorage.removeItem('X-Authorization')
        window.history.back()
        window.PalauAPI.user.refreshToken((val) => {
          sessionStorage.setItem('X-Authorization', val)
        })
      } else {
        return Promise.reject(new Error(res.message || 'Error'))
      }
    } else {
      return res
    }
  },
  (error) => {
    console.log('err' + error)
    return Promise.reject(error)
  }
)
Vue.$request = service
export default service
